export default __webpack_public_path__ + "fc3461cb087c7c4202a174c10e48134c.png";